import './Clouds.scss';

export function Clouds() {
    return (
        <div className="clouds">
            <img src="images/cloud-1.png" className="cloud" />
            <img src="images/cloud-2.png" className="cloud" />
        </div>
    )
}